(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-megamenu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sidebar = document.querySelector('[data-sbmm]');
    var mega = document.querySelector('[data-sbmm-mega]');
    var backdrop = document.querySelector('[data-sbmm-backdrop]');
    if (!sidebar || !mega) return;

    var panels = mega.querySelectorAll('.sbmm-panel');
    var rows = sidebar.querySelectorAll('.sbmm-rail-row-has-children');
    var openTimer = null;
    var closeTimer = null;

    function setAnnouncementHeight() {
      var ann = document.querySelector('.site-announcement');
      if (!ann) return;
      var h = ann.offsetHeight;
      if (h > 0) {
        document.documentElement.style.setProperty('--sbmm-announce-h', h + 'px');
      }
    }
    setAnnouncementHeight();
    window.addEventListener('resize', setAnnouncementHeight);
    window.addEventListener('load', setAnnouncementHeight);

    function setHeaderOffset() {
      // Sum heights of the fixed elements above main: announcement bar + header.
      var ann = document.querySelector('.site-announcement');
      var hdr = document.querySelector('.site-header');
      var total = 0;
      if (ann) total += ann.offsetHeight;
      if (hdr) total += hdr.offsetHeight;
      if (total < 60) return; // nonsense reading; skip
      document.documentElement.style.setProperty('--sbmm-top', total + 'px');
    }

    setHeaderOffset();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setHeaderOffset);
    }
    if (document.readyState !== 'complete') {
      window.addEventListener('load', setHeaderOffset);
    }
    // ResizeObserver catches header height changes from web fonts loading,
    // logo image lazy-load, announcement bar mounting, etc. — before the
    // 'load' event would fire.
    if (window.ResizeObserver) {
      var __hdr = document.querySelector('.site-header');
      var __ann = document.querySelector('.site-announcement');
      var __ro = new ResizeObserver(setHeaderOffset);
      if (__hdr) __ro.observe(__hdr);
      if (__ann) __ro.observe(__ann);
    }
    window.addEventListener('resize', setHeaderOffset);

    function closeAll() {
      mega.classList.remove('is-open');
      mega.setAttribute('aria-hidden', 'true');
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      rows.forEach(function (r) { r.classList.remove('is-open'); });
      if (backdrop) backdrop.classList.remove('is-open');
    }

    // Lazy thumbnails: cards render data-thumb="URL" instead of an inline
    // background-image so the hidden mega panels don't download every thumb
    // on every page load. Hydrate a scope's thumbs on first reveal;
    // idempotent — the attribute is removed after use.
    function hydrateThumbs(scope) {
      if (!scope) return;
      var thumbs = scope.querySelectorAll('[data-thumb]');
      for (var i = 0; i < thumbs.length; i++) {
        var url = thumbs[i].getAttribute('data-thumb');
        thumbs[i].removeAttribute('data-thumb');
        if (url) thumbs[i].style.backgroundImage = "url('" + url + "')";
      }
    }

    function openCategory(handle) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      var panel = mega.querySelector('.sbmm-panel[data-cat="' + cssEscape(handle) + '"]');
      if (!panel) { closeAll(); return; }
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      hydrateThumbs(panel.querySelector('.sbmm-col-root'));
      panel.classList.add('is-open');
      rows.forEach(function (r) {
        r.classList.toggle('is-open', r.getAttribute('data-cat') === handle);
      });
      resetPanelColumns(panel);
      mega.classList.add('is-open');
      mega.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
    }

    function resetPanelColumns(panel) {
      panel.querySelectorAll('.sbmm-col').forEach(function (c) {
        if (!c.classList.contains('sbmm-col-root')) c.classList.remove('is-open');
      });
      panel.querySelectorAll('.sbmm-leaf').forEach(function (l) {
        l.classList.remove('is-open');
      });
      panel.querySelectorAll('.sbmm-card.is-active').forEach(function (c) {
        c.classList.remove('is-active');
      });
    }

    function cssEscape(s) {
      if (window.CSS && CSS.escape) return CSS.escape(s);
      return String(s).replace(/["\\]/g, '\\$&');
    }

    function onCardEnter(card) {
      var panel = card.closest('.sbmm-panel');
      if (!panel) return;
      var depth = parseInt(card.getAttribute('data-depth'), 10);
      var path = card.getAttribute('data-path');

      // Clear active + close columns/leaves at this depth and deeper
      panel.querySelectorAll('.sbmm-card.is-active').forEach(function (c) {
        var d = parseInt(c.getAttribute('data-depth'), 10);
        if (d >= depth) c.classList.remove('is-active');
      });
      panel.querySelectorAll('.sbmm-col.is-open').forEach(function (c) {
        if (c.classList.contains('sbmm-col-root')) return;
        var p = c.getAttribute('data-col-path') || '';
        var pDepth = p ? p.split('/').length + 1 : 2;
        if (pDepth > depth) c.classList.remove('is-open');
      });
      panel.querySelectorAll('.sbmm-leaf.is-open').forEach(function (l) {
        l.classList.remove('is-open');
      });

      card.classList.add('is-active');

      if (card.getAttribute('data-has-children') === '1') {
        var nextCol = panel.querySelector('.sbmm-col[data-col-path="' + cssEscape(path) + '"]');
        if (nextCol) {
          hydrateThumbs(nextCol);
          nextCol.classList.add('is-open');
        }
      } else {
        var leaf = panel.querySelector('.sbmm-leaf[data-gallery-for="' + cssEscape(path) + '"]');
        if (leaf) {
          hydrateThumbs(leaf);
          leaf.classList.add('is-open');
        }
      }
    }

    // Click-driven: collapse a column and everything deeper, then deactivate
    // the card that spawned it. Back on the first (root) column closes the
    // whole panel. Columns carry data-col-path; the spawning card's data-path
    // equals that path.
    function back(col) {
      if (!col) return;
      if (col.classList.contains('sbmm-col-root')) { closeAll(); return; }
      var panel = col.closest('.sbmm-panel');
      if (!panel) { closeAll(); return; }
      var path = col.getAttribute('data-col-path') || '';
      var prefix = path + '/';
      panel.querySelectorAll('.sbmm-col').forEach(function (c) {
        if (c.classList.contains('sbmm-col-root')) return;
        var p = c.getAttribute('data-col-path') || '';
        if (p === path || p.indexOf(prefix) === 0) c.classList.remove('is-open');
      });
      panel.querySelectorAll('.sbmm-leaf.is-open').forEach(function (l) {
        var g = l.getAttribute('data-gallery-for') || '';
        if (g.indexOf(prefix) === 0) l.classList.remove('is-open');
      });
      panel.querySelectorAll('.sbmm-card.is-active').forEach(function (c) {
        var p = c.getAttribute('data-path') || '';
        if (p === path || p.indexOf(prefix) === 0) c.classList.remove('is-active');
      });
    }

    // L1 rail rows: click opens the category panel (or toggles it closed if
    // it's already the open one). Rows never navigate — "Δείτε όλα" inside the
    // column handles reaching the category's own collection page.
    rows.forEach(function (row) {
      var handle = row.getAttribute('data-cat');
      // Prewarm: start fetching the category's first-column thumbs on hover,
      // before the click opens the panel and its slide-in animation runs.
      row.addEventListener('pointerenter', function () {
        var panel = mega.querySelector('.sbmm-panel[data-cat="' + cssEscape(handle) + '"]');
        if (panel) hydrateThumbs(panel.querySelector('.sbmm-col-root'));
      });
      row.addEventListener('click', function (e) {
        e.preventDefault();
        if (row.classList.contains('is-open')) {
          closeAll();
        } else {
          openCategory(handle);
        }
      });
    });

    // Cards inside panels: a card with children drills into its column; a leaf
    // card (no children) navigates via its href.
    mega.addEventListener('click', function (e) {
      var back_btn = e.target.closest('[data-sbmm-back]');
      if (back_btn) {
        e.preventDefault();
        back(back_btn.closest('.sbmm-col'));
        return;
      }
      var close_btn = e.target.closest('[data-sbmm-close]');
      if (close_btn) {
        e.preventDefault();
        closeAll();
        return;
      }
      var card = e.target.closest('.sbmm-card');
      if (card && card.getAttribute('data-has-children') === '1') {
        e.preventDefault();
        onCardEnter(card);
      }
    });

    // Prewarm: hovering a drillable card starts fetching its child column's
    // thumbs before the click reveals it. Cheap after first hydration (the
    // data-thumb attributes are gone, so the query matches nothing).
    mega.addEventListener('pointerover', function (e) {
      var card = e.target.closest('.sbmm-card[data-has-children="1"]');
      if (!card) return;
      var panel = card.closest('.sbmm-panel');
      if (!panel) return;
      var nextCol = panel.querySelector('.sbmm-col[data-col-path="' + cssEscape(card.getAttribute('data-path')) + '"]');
      if (nextCol) hydrateThumbs(nextCol);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeAll);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
